// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc89db7e","239":"4044c349","667":"e03f03f8"}[chunkId] + ".chunk.js";
};